import { useState } from "react"

function useModalManager() {
    // state
    const [ isVisible, setIsVisible ] = useState(false);
    const [ currentModal, setCurrentModal ] = useState("");

    function showModal() {
        setIsVisible(true);
    }

    function hideModal() {
        setIsVisible(false);
    }

    return {
        isVisible,
        showModal,
        hideModal,
        currentModal,
        setCurrentModal
    }
    
}

export { useModalManager }